export default "__VITE_ASSET__3BJZcKq5__"